import { Flex, Text } from '@bb/elements-web';
import { Input } from 'components';
import React, { useContext } from 'react';
import styled from 'styled-components';
import VirtualTabContext from './VirtualTabContext';

const CoopDetails: React.FC = () => {
  const { coop, setCoop } = useContext(VirtualTabContext);

  if (!coop) return null;

  return (
    <StyledFlex vertical gap="middle">
      <div>
        <Text thickness="bold">Name: </Text>
        <Text>{coop.name}</Text>
      </div>
      <div>
        <Text thickness="bold" size="large">
          {coop.org?.name || ''}
        </Text>
        <br />
        <Text>{coop.org?.address || ''}</Text>
      </div>
      <div>
        <Text thickness="bold">Mobile: </Text>
        <Input
          phoneNumberMask
          value={coop.phone}
          onChange={e => {
            const { value } = e.currentTarget;
            setCoop(prev => ({ ...prev!, phone: value }));
          }}
          data-cy="virtualShowing-edit-mobile"
        />
      </div>
      <div>
        <Text thickness="bold">Email: </Text>
        <Text>{coop.email}</Text>
      </div>
    </StyledFlex>
  );
};

const StyledFlex = styled(Flex)`
  padding: 15px 0;
`;

export default CoopDetails;
